import { render, staticRenderFns } from "./EquipmentCard.vue?vue&type=template&id=fda1ccd8&scoped=true"
import script from "./EquipmentCard.vue?vue&type=script&lang=js"
export * from "./EquipmentCard.vue?vue&type=script&lang=js"
import style0 from "./EquipmentCard.vue?vue&type=style&index=0&id=fda1ccd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda1ccd8",
  null
  
)

export default component.exports